import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { RightNavItems } from "./right-nav-items";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import {
  selectNotifications,
  updateNotificationToState,
} from "@/store/slices/notifications/notificationsSlice";
import { useEffect, useState } from "react";
import * as styles from "./notification-menu/style.module.scss";
import TruncateTooltip, {
  TooltipComponent,
} from "@/components/truncate-with-tooltip";
import storage from "@/services/storage";
import useLeadNotifications from "@/hooks/leads/useLeadNotifiaction";
import { useDispatch } from "react-redux";
import { cloneDeep } from "@/services/generic.methods";
import { useTheme } from "@mui/material";

const DesktopMenu = ({ handleMenuOpen, displayName }) => {
  let { pathname } = useRouter();
  const theme = useTheme();
  const { notifications } = useSelector(selectNotifications);
  const [unreadCount, setUnreadCount] = useState(0);
  const [animateBell, setAnimateBell] = useState(null);
  const profile = JSON.parse(storage.getItem("Profile"));
  const { setNotificationIsRead } = useLeadNotifications();
  const dispatch = useDispatch();

  useEffect(() => {
    const isSeen = notifications?.[0]?.isSeen;
    const count = notifications?.filter(
      (notification) => !notification?.isNotificationRead
    )?.length;
    setUnreadCount(isSeen ? 0 : count);
  }, [notifications]);

  useEffect(() => {
    if (unreadCount) {
      setTimeout(() => {
        setAnimateBell(styles.animateBell);
        setTimeout(() => {
          setAnimateBell(null);
        }, 600);
      }, 400);
    }
  }, [unreadCount]);

  const handleItemCliked = async (e, name) => {
    if (name == "notifications" && notifications.length) {
      const mostRecentNotification = { ...notifications[0] };
      if (!mostRecentNotification.isSeen) {
        setNotificationIsRead(mostRecentNotification.id);
        mostRecentNotification.isSeen = true;
        dispatch(updateNotificationToState(mostRecentNotification));
      }
    }
    handleMenuOpen(e);
  };

  return (
    //  on desktop screen right hand icons
    <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
      {RightNavItems.map((item) => (
        <TooltipComponent
          key={item?.id}
          showTooltip={item?.showTooltip}
          text={item?.title}
        >
          <IconButton
            key={item?.id}
            size="large"
            aria-label={item?.name}
            color="inherit"
            sx={{ color: "var(--palette-header_text) !important" }}
            name={item?.name}
            className={`menu-icon-btn ${
              item?.name == "settings" && pathname?.includes("/crm/settings")
                ? "active"
                : ""
            }`}
            aria-controls={item?.name}
            aria-haspopup={item?.haspopup}
            onClick={(e) =>
              item?.haspopup ? handleItemCliked(e, item.name) : null
            }
            disableRipple={true}
          >
            {item?.link ? (
              <Link
                href={item?.link}
                target={item.redirect ? "_blank" : "_self"}
              >
                <span
                  style={{
                    color: "var(--palette-header_text)",
                  }}
                >
                  {item?.icon}
                </span>
              </Link>
            ) : item.name === "notifications" ? (
              item?.icon(unreadCount, animateBell)
            ) : item.name === "profile" ? (
              item?.icon(profile)
            ) : (
              item?.icon
            )}
            {item?.name === "profile" && (
              <Typography
                sx={{
                  ml: "5px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                component="span"
                variant="body2"
                color="custom.header_text"
              >
                <TruncateTooltip
                  text={displayName}
                  limit={15}
                  sx={{
                    fontWeight: 500,
                    fontSize: "1rem",
                    // color: "var(--primary)",
                    color: "custom.header_text",
                  }}
                />
                <ExpandMoreIcon fontSize="small" />
              </Typography>
            )}
          </IconButton>
        </TooltipComponent>
      ))}
    </Box>
  );
};

export default DesktopMenu;
